/*
  prepends to the key used to set/retrieve values to/from localStorage. storage keys are unique relative
  to a hostname. since navisphere apps all share a common hostname, they must be unique so that they don't
  inadvertently clobber another app's token
*/
export const APP_STORAGE_ITEM_PREFIX = 'NavisphereOnline';
export const AUTH0_AUDIENCE = 'Navisphere-Online-API';
export const USER_FILTER_KEY = 'NavisphereOnline.PO.UserFilters';
export const DEFAULT_PAGE_SIZE = 25;

export enum BucketTypes {
  new = 1,
  confirmed = 2,
  buyerReview = 3,
  supplierConfirmation = 4,
  revised = 10,
  onHold = 21,
  shipped = 30
}

export interface Bucket {
  bucketTypeId: number;
  orderBy: string;
  orderByDirection: 'Ascending' | 'Descending';
  state: string;
}
export const poBuckets: { [TKey: string]: Bucket } = {
  new: {
    bucketTypeId: 1,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'New'
  },
  revised: {
    bucketTypeId: 10,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Revised'
  },
  confirmed: {
    bucketTypeId: 2,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Confirmed'
  },
  canceled: {
    bucketTypeId: 5,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Canceled'
  },
  'buyer-review': {
    bucketTypeId: 3,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Buyer Review'
  },
  'supplier-confirmation': {
    bucketTypeId: 4,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Supplier Confirmation'
  },
  'on-hold': {
    bucketTypeId: 21,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Hold'
  },
  shipped: {
    bucketTypeId: 30,
    orderBy: 'ExpectedAcknowledgementDate',
    orderByDirection: 'Ascending',
    state: 'Shipped'
  },
};

// TODO: Make this an enum.
export const changeRequestStatuses = {
  approved: 'Approved',
  open: 'Open',
  closed: 'Closed'
};

// TODO: Make this an enum.
export const purchaseOrderItemOrderBy = {
  PurchaseOrderItemId: 0,
  CustomerPoLineNum: 10,
  CustomerItemId: 20,
  DeliveryStartDate: 30,
  PickupStartDate: 40,
  ExpectedAcknowledgementDate: 45,
  StateId: 50
};

export enum ItemState {
  New = 1,
  Accepted = 2,
  Revised = 3
}

export enum EntityType {
  PurchaseOrder = 1,
  ChangeRequest = 2,
  HoldRequest = 4
}

export enum NotificationTypeEnum {
  OrderConfirmationMgmt = 1
}

export enum ChangeRequestOrdering {
  CreatedDate = 0,
  StatusChanagedDate = 1
}

export enum ConversationSectionEnum {
  Conversation = 1,
  Notes = 2
}

export enum SupplierConfirmationKind {
  New = 0,
  Revised = 1,
  ChangeRequest = 2,
}

// TODO: Make this an enum.
export const REGEX = {
  INTEGERS: /^\d+$/,
  DECIMALS: /^\d*\.?\d*$/
};
